import React, { Component } from 'react';

class InfoPane extends Component {
  render = () => {
    if (this.props.data === null) {
      return (
        <div id="infoPane"></div>
      )
    }

    if (this.props.data.type === "dc") {
      return (
        <div id="infoPane">
          {
            this.props.data.notice && 
            <div className="alert alert-danger" style={{whiteSpace: "pre-line"}}>
              <span className="glyphicon glyphicon-exclamation-sign"></span> {this.props.data.notice}
            </div>
          }
          {
            !this.props.data.ldap &&
            <div className="alert alert-warning alert-orange" style={{whiteSpace: "pre-line"}}>
              <span className="glyphicon glyphicon-info-sign"></span> {`Cannot use DCNet password. Must use ${this.props.data.name.toUpperCase()} password.`}
            </div>
          }
          <h3>{this.props.data.name}</h3>
          <p><i className="glyphicon glyphicon-link" /> <a href={this.props.data.url} target="_blank">{this.props.data.url}</a></p>
        </div>
      )
    } else {
      return (
        <div id = "infoPane">
          {
            this.props.data.notice && 
            <div className="alert alert-danger" style={{whiteSpace: "pre-line"}}>
              <span className="glyphicon glyphicon-exclamation-sign"></span> {this.props.data.notice}
            </div>
          }
          <h3>{this.props.data.name}</h3>
          <p className = "infoGroup"><b>Contact</b></p>
          <p><i className="glyphicon glyphicon-user" /> {this.props.data.contactName}</p>
          <p><i className="glyphicon glyphicon-envelope" /> <a href={`mailto:${this.props.data.email}`}>{this.props.data.email}</a></p>
          <p><i className="glyphicon glyphicon-phone" /> {this.props.data.phone}</p>
          <hr></hr>
          <p className = "infoGroup"><b>Address</b></p>
          <p><i className="glyphicon glyphicon-map-marker" /> {this.props.data.address}</p>

        </div>
      )
    }
  }
}

export default InfoPane;


// WEBPACK FOOTER //
// ./src/Components/sites/InfoPane.js